import React from "react";
import Card from "react-bootstrap/Card";
import {ImPointRight} from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{textAlign: "justify"}}>
            Hi Everyone, I am <span className="purple">Sunil Poudel </span>
            from <span className="purple"> United States</span>
            <br/>
            I am currently pursuing a Master's in Computer Science at MIU.
            <br/>
            <br/>
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight/> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Crafting Innovative Ideas
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Walk with me into the future—as allies, as friends!"{" "}
          </p>
          <footer className="blockquote-footer">Sunil</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
